<template>
  <q-btn
    data-test-id="consumer-header-search-button"
    flat
    :dense="$q.screen.lt.sm"
    round
    size="12px"
    icon="fal fa-magnifying-glass"
    @click="$emit('search')"
  />
</template>

<script>
export default {
  name: 'SearchButton',
  emits: ['search']
}
</script>
